import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import * as moment from 'moment';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { Box, LastState} from '@src/components';

// typing
interface LocalProps extends PropsList {
    onCycle?: Function;
    startPicker?: any;
    endPicker?: any;
    getState?: string;
}

interface LocalState extends StateList {
}

// style
const style = css`

`;

// component
export class Cycles extends ProtoList<LocalProps, LocalState> {
    

    async componentWillMount() {
        const state = {
           startDate: this.props.startPicker?moment(this.props.startPicker):moment().subtract(14, 'days'),
            // startDate: moment('2018-01-01'),
            endDate: this.props.endPicker?moment(this.props.endPicker):moment()
        };
        this.setState(state, () => {
            this.loadWithFilters(this.state);
        });
    }
    
    downloadReport( row ) {
        window.open( row.number + '/' + row.status );
    }

	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { onCycle,getState } = this.props;
        const { loading, items = [], tableProps } = this.state;

        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
                getTrProps: (state, row, column) => {
                    if (!row) return {};
                    return {
                        className: classNames("clickable"),
                        onClick: (e) => {
                            if (onCycle) onCycle({cycleid: row.original.cycleid})
                        }
                    };
                }
            }
        }
        localTableProps.loading = loading;

        const columns = [
            { Header: _('cycles_col_number', 'BatteryCycle'), accessor: 'number', className: "id" },
            { Header: _('cycles_col_starttime', 'BatteryCycle'), id: 'starttime', accessor: v => formatters.datetime(v.starttime) },
            { Header: _('cycles_col_chargedah', 'BatteryCycle'), accessor: 'chargedah', className: "number" },
            { Header: _('cycles_col_dischargedah', 'BatteryCycle'), accessor: 'dischargedah', className: "number" },
            { Header: _('cycles_col_endvoltage', 'BatteryCycle'), id: 'endvoltage', accessor: v => `${v.endvoltage} V`, className: "number", sortable: false,filterable: false},
            { Header: _('cycles_col_startvoltage', 'BatteryCycle'), id: 'startvoltage', accessor: v => `${v.startvoltage} V`, className: "number", sortable: false,filterable: false},
            { Header: _('cycles_col_maxdischarge', 'BatteryCycle'), accessor: 'maxdischarge', className: "number" , sortable: false,filterable: false},
            { Header: _('cycles_col_duration', 'BatteryCycle'), accessor: 'duration', sortable: false,filterable: false},
            { Header: _('cycles_col_starttemp', 'BatteryCycle'), id: 'starttemp', accessor: v => `${v.starttemp} °C`, className: "number", sortable: false,filterable: false},
            { Header: _('cycles_col_endtemp', 'BatteryCycle'), id: 'endtemp', accessor: v => `${v.endtemp} °C`, className: "number", sortable: false,filterable: false},
            { Header: _('cycles_col_chargetype', 'BatteryCycle'), accessor: 'chargingtype' , sortable: false,filterable: false},
            { Header: _('cycles_col_outcome', 'BatteryCycle'), id: 'status', accessor: v => formatters.status(v.status), className: "bullet", sortable: false,filterable: false},
            { Header: _('cycles_err_details', 'BatteryCycle'), accessor: 'mostseverealert', sortable: false,filterable: false },
            // { Header: _('cycles_err_details', 'BatteryCycle'), accessor: 'report', className: "bullet", Cell: row => (row.row.status > 0) ? (
            //         <a onClick={() => this.downloadReport(row.row)}>
            //             <i className="fa fa-warning"></i>
            //         </a>
            //     ) : null
            // },
        ];

		const toolbar = () => (
            <DateRangePicker {...this.DatePickerProps()} />
		);
        
		return (

            <>
            <>
            <LastState  cpt={"LastState"} get={getState} />
            </>
            <Box
                title={_('cycles_title', 'BatteryCycle')}
                toolbar={toolbar}
                collapsed={false}
            >
                <div className={style}>
                    <ReactTable
                        {...localTableProps}
                        data={items}
                        columns={columns}
                    />
                </div>
            </Box>
            </>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryCycle/Cycles.tsx